import { api } from 'api';

import { Filter } from './summary-filter';
import { notify } from 'libs/common';

export const Summary = () => {
  const submit = (data) => {
    api.call('reports.get_xls', { filter_params: data }).catch((error) => notify('Сводный отчёт', error.toString()));
  };

  return <Filter onSubmit={submit} />;
};
